/**
 * MIRA Alert Component
 * Wraps Shadcn Alert with MIRA design system styles
 */

import React from 'react';
import {
  Alert as ShadcnAlert,
  AlertTitle as ShadcnAlertTitle,
  AlertDescription as ShadcnAlertDescription,
} from '@/components/ui/alert';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/feedback/alert.module.css';

export const Alert = React.forwardRef(
  ({ className, variant = 'default', ...props }, ref) => {
    return (
      <ShadcnAlert
        ref={ref}
        variant={variant}
        className={cn(styles.miraAlert, className)}
        {...props}
      />
    );
  }
);

Alert.displayName = 'MiraAlert';

export const AlertTitle = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAlertTitle
        ref={ref}
        className={cn(styles.miraAlertTitle, className)}
        {...props}
      />
    );
  }
);

AlertTitle.displayName = 'MiraAlertTitle';

export const AlertDescription = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAlertDescription
        ref={ref}
        className={cn(styles.miraAlertDescription, className)}
        {...props}
      />
    );
  }
);

AlertDescription.displayName = 'MiraAlertDescription';
